var exports = {
  "R": "x127c5a35--bc7109--preloader",
  "t": "x127c5a35--bc7109--spin",
};

module.exports = exports;
